import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
// eslint-disable-next-line import/no-unresolved
import { init } from '@module-federation/enhanced/runtime';
import Spinner from './Spinner';
import { getApiTarget } from '../utils/apiTarget';

let federatedHost = null;
export const initFederatedHost = (config) => {
  if (federatedHost) {
    return federatedHost;
  }
  federatedHost = init({
    name: 'host',
    remotes: [
      {
        name: 'clinicianManagement',
        entry: config.scheduleCMScriptPath,
        type: 'var',
      },
    ],
    shared: {
      react: {
        singleton: true,
        get: () => Promise.resolve(() => React),
      },
      'react-dom': {
        singleton: true,
        get: () => Promise.resolve(() => ReactDOM),
      },
    },
    inBrowser: true,
  });
  return federatedHost;
};

const useRemoteModuleInjection = (config) => {
  const [RemoteComponent, setRemoteComponent] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadRemoteModule = async () => {
      try {
        const host = initFederatedHost(config);
        const remoteModule = await host.loadRemote(
          config.remoteModulePath || '',
        );

        if (isMounted) {
          setRemoteComponent(
            () => remoteModule.default || remoteModule,
          );
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error during remote module loading:', error);
      }
    };

    loadRemoteModule();

    return () => {
      isMounted = false;
    };
  }, [config]);

  return RemoteComponent;
};

const useRemoteVersion = (config) => {
  const [version, setVersion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadVersion = async () => {
      try {
        const host = initFederatedHost(config);
        const versionModule = await host.loadRemote(
          'clinicianManagement/Version',
        );
        setVersion(versionModule.default || versionModule);
      } catch (err) {
        setError(err);
        console.error('Error loading remote version:', err);
      } finally {
        setLoading(false);
      }
    };

    loadVersion();
  }, [config]);

  return { version, loading, error };
};
const CM_CONTAINER_ID = 'clinician-management';
export const ScheduleClinicianManagement = ({
  config,
  accessToken,
  idToken,
  selectedProviderId,
  pageType,
  logoutUrl,
  operationHandlers,
}) => {
  const RemoteComponent = useRemoteModuleInjection(config);
  const { version } = useRemoteVersion(config);

  if (version) {
    console.log('Clinician Management version:', version.version);
  }
  return (
    <div id={CM_CONTAINER_ID}>
      {RemoteComponent ? (
        <RemoteComponent
          accessToken={accessToken}
          idToken={idToken}
          selectedProviderId={selectedProviderId}
          remoteCheck={config.remoteCheck ?? false}
          pageType={pageType}
          logoutUrl={logoutUrl}
          operationHandlers={operationHandlers}
          apiTarget={getApiTarget()}
        />
      ) : (
        <Spinner loading />
      )}
    </div>
  );
};
